import { all, spawn, call } from 'redux-saga/effects';
import userAuthSaga from './userAuth/saga';
import feesSaga from './fees/saga';
import docsSage from './docs/saga';
import titleCheckSaga from './titleCheck/saga';

export default function* rootSaga() {
  const sagas = [
    userAuthSaga,
    feesSaga,
    docsSage,
    titleCheckSaga
  ];

  yield all(sagas.map(saga =>
    spawn(function* () {
      while (true) {
        try {
          yield call(saga);
          break;
        } catch (e) {
          console.log(e);
        }
      }
    }))
  );
}
